class EventManager {
    constructor() {
        this.dispatch = this.dispatch.bind(this);
        this.subscribe = this.subscribe.bind(this);
        this.dispatchAnchorsAction = this.dispatchAnchorsAction.bind(this);
    }

    subscribeAnchorClick(selector, fn, unsubscribe = false) {
        // @TODO implement options support
        // @TODO rename shorter
        this._anchorsClickQueue = this._anchorsClickQueue || new Map();
        if (!this._anchorsClickQueue.has(selector)) {
            this._anchorsClickQueue.set(selector, []);
        }
        if (this._anchorsClickQueue.get(selector).indexOf(fn) < 0) {
            const fns = this._anchorsClickQueue.get(selector); // go deeper to unsubscribe
            if (unsubscribe) {
                fns.splice(fn, 1);
                this._anchorsClickQueue.set(selector, fns);
            } else {
                fns.push(fn);
                this._anchorsClickQueue.set(selector, fns);
            }
        }
    }

    dispatchAnchorsAction(e) {
        if ((e.type === 'click' || e.keyCode == 13) && this._anchorsClickQueue) {
            let target = e.target;
            while (target.tagName !== 'A') {
                if (target.parentNode) {
                    target = target.parentNode;
                } else {
                    target = null;
                    break;
                }
            }
            if (target) {
                const newE = this.cloneEvent(e, {currentTarget: target});
                this._anchorsClickQueue.forEach((fns, selector) => {
                    if (selector === target || (typeof selector === 'string' && target.matches(selector))) {
                        fns.map(fn => {
                            fn(newE);
                        });
                    }
                });
            }
        }
    }

    subscribe(type, fn, unsubscribe = false, options = {}) {
        // @TODO implement options support
        const queueName = type + 'Queue';
        this[queueName] = this[queueName] || [];
        const isInQueue = this[queueName].indexOf(fn) >= 0;

        if (unsubscribe) {
            if (isInQueue) {
                this[queueName].splice(this[queueName].indexOf(fn), 1);
            }
            return;
        }
        if (isInQueue) {
            console.warn(
                'Attempting to assign duplicating callback to a performance sensitive event listener. Refusing.'
            );
        } else {
            this[queueName].push(fn);
        }
    }

    dispatch(e) {
        const type = e.type || e;
        if (this[type + 'Queue']) {
            this[type + 'Queue'].map(f => f(e));
        }
    }

    cloneEvent(e, newE) {
        if (e === undefined || e === null) return undefined;
        function ClonedEvent() {}
        let clone = new ClonedEvent();
        for (let p in e) {
            let d = Object.getOwnPropertyDescriptor(e, p);
            if (d && (d.get || d.set)) Object.defineProperty(clone, p, d);
            else if (typeof e[p] === 'function') {
                // cloned event methods like .preventDefault() won't work
                clone[p] = (...args) => e[p](...args);
            } else clone[p] = newE[p] || e[p];
        }
        Object.setPrototypeOf(clone, e);
        return clone;
    }
}

module.exports = EventManager;
